/** Quorum + docs verification banner. Reads /committee/quorum-verify. */
import { CheckCircle2, AlertTriangle, Lock, Unlock } from "lucide-react";

export default function QuorumStatusBanner({ quorum, accent = "#F5B82E" }) {
  if (!quorum) return null;
  const unlocked = quorum.full_features_unlocked;
  return (
    <div
      className={`mt-6 cs-card rounded-2xl p-5 flex flex-wrap items-center gap-4 ${
        unlocked ? "border border-emerald-500/40" : "border border-amber-500/25"
      }`}
      data-testid="quorum-status-banner"
    >
      <div className="flex items-center gap-3">
        {unlocked
          ? <Unlock size={18} className="text-emerald-300" />
          : <Lock size={18} className="text-amber-300" />}
        <div>
          <div className="text-[10px] tracking-[0.28em] uppercase text-white/55">Dashboard status</div>
          <div className="text-sm mt-0.5">
            {unlocked
              ? <span className="text-emerald-300 font-semibold" data-testid="quorum-unlocked">Fully activated — all governance tools enabled</span>
              : <span className="text-amber-300 font-semibold" data-testid="quorum-locked">Provisional — complete the checklist below</span>}
          </div>
        </div>
      </div>
      <div className="flex-1 min-w-[220px] flex flex-wrap gap-2 justify-end">
        <StatusPill ok={quorum.docs?.certificate_uploaded}
                    label="Certificate" testid="pill-certificate" />
        <StatusPill ok={quorum.docs?.bylaws_uploaded}
                    label="By-Laws"    testid="pill-bylaws" />
        <StatusPill ok={Boolean(quorum.docs?.registration_number)}
                    label="Reg #"      testid="pill-reg-no" />
        <StatusPill ok={quorum.committee?.quorum_met}
                    label={`Committee ${quorum.committee?.size || 0}/${quorum.committee?.quorum_min || 3}`}
                    testid="pill-committee-quorum" />
      </div>
    </div>
  );
}

function StatusPill({ ok, label, testid }) {
  return (
    <span
      className={`px-2.5 py-1 rounded-full text-[10px] tracking-[0.18em] uppercase flex items-center gap-1.5 border ${
        ok
          ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-300"
          : "bg-amber-500/10 border-amber-500/30 text-amber-300"
      }`}
      data-testid={testid}
    >
      {ok ? <CheckCircle2 size={11} /> : <AlertTriangle size={11} />}
      {label}
    </span>
  );
}
